export default {
  title: 'Sei sicuro?',
  description: 'I seguenti gruppi di modificatori (inclusi i loro modificatori) verranno eliminati:',
  buttons: {
    yes: 'Sì',
    no: 'No',
  },
  toasts: {
    modifier_group_got_deleted: 'Gruppi di modificatori eliminati',
    failed_to_delete_modifier_group: 'Eliminazione del gruppo di modificatori fallita',
  },
};
